'use strict';
const angular = require('angular');

export class UserLookupComponent {
  /*@ngInject*/
  constructor(User) {
    this.User = User;

    this.data = [];

    this.User.query((data) => {
      this.data = data;
      this.dataInitComplete = true;
    }, err => {
      console.log("Could not retrieve properties.")
    });
  }

  $onInit = function () {
    this.config = this.resolve.config;
  };

  ok(user) {
    this.close({$value: user});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.userLookup', [])
  .component('userLookup', {
    template: require('./user-lookup.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: UserLookupComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/user-lookup/user-lookup.component.js